module.exports = __webpack_public_path__ + "img/avatar_cn.39b6c5ba.png";